import { z } from "zod";
import { assetIdSchema } from "./workIds";

export const assetTreeSearchSchema = z
  .object({
    assetSearch: z.string().max(500).optional(),
    /**
     * @deprecated Superseded by `assetKind`. Retained only so older
     * bookmarked/shared links with an `assetType` (asset-type-name) value
     * still parse. The asset hierarchy screen no longer writes this field.
     */
    assetType: z.string().trim().min(1).max(120).optional(),
    // A stale or hand-edited kind falls back to no filter instead of failing.
    assetKind: z.enum(["ASSET", "LOCATION"]).optional().catch(undefined),
    // Only approved sort fields and directions are kept; anything else falls
    // back to the default order instead of failing the route.
    assetSort: z.enum(["name", "type"]).optional().catch(undefined),
    assetSortDir: z.enum(["asc", "desc"]).optional().catch(undefined),
    assetSelectedId: assetIdSchema.optional(),
    assetCollapsedIds: z.array(assetIdSchema).max(500).optional(),
    /** The asset currently open in the asset detail side sheet, if any. */
    assetOpenId: assetIdSchema.optional(),
  })
  .passthrough();

export type AssetTreeSearch = z.infer<typeof assetTreeSearchSchema>;

export type AssetSortField = NonNullable<AssetTreeSearch["assetSort"]>;
export type AssetSortDir = NonNullable<AssetTreeSearch["assetSortDir"]>;
export type AssetSort = { field: AssetSortField; dir: AssetSortDir };

/**
 * The active sort, or undefined for the default hierarchy order. A direction
 * without a field is ignored; a field without a direction sorts ascending.
 */
export function resolveAssetSort(
  search: Pick<AssetTreeSearch, "assetSort" | "assetSortDir"> | undefined,
): AssetSort | undefined {
  if (!search?.assetSort) return undefined;
  return { field: search.assetSort, dir: search.assetSortDir ?? "asc" };
}
